(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mm-filter]').forEach(button=>button.addEventListener('click',()=>{const scope=button.closest('.mm-selection');scope.querySelectorAll('[data-mm-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));scope.querySelectorAll('[data-mm-style]').forEach(card=>card.hidden=button.dataset.mmFilter!=='all'&&card.dataset.mmStyle!==button.dataset.mmFilter);}));

  } catch(e) { console.error(e); }
})();
})();
